import type { Bytes } from "@pdfking/structs"
import type { AsyncSequence } from "@pdfking/tfunc"

// `chunk_size` answers for each output chunk by its index, so a stream can
// start with small pieces and grow
export const ResizeUInt8 = async function* (
  chunks: AsyncSequence<Uint8Array>,
  chunk_size: (index: number) => Bytes
): AsyncGenerator<Uint8Array> {
  let index = 0
  let pending = new Uint8Array(chunk_size(index))
  let offset = 0

  for await (const chunk of chunks) {
    let chunkOffset = 0

    while (chunkOffset < chunk.length) {
      const spaceLeft = pending.length - offset
      const remaining = chunk.length - chunkOffset

      if (remaining <= spaceLeft) {
        pending.set(chunk.subarray(chunkOffset), offset)
        offset += remaining
        break
      }

      pending.set(chunk.subarray(chunkOffset, chunkOffset + spaceLeft), offset)
      chunkOffset += spaceLeft
      yield pending

      pending = new Uint8Array(chunk_size(++index))
      offset = 0
    }
  }

  if (offset > 0) {
    yield pending.subarray(0, offset)
  }
}
